import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=4fdbb312"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/wp-content/themes/svea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fdbb312')) {
      api.createRecord('4fdbb312', component.options)
    } else {
      api.reload('4fdbb312', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=4fdbb312", function () {
      api.rerender('4fdbb312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/Faq.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/Faq.vue
// module id = 126
// module chunks = 0